<div class="seller-page">
  <h1>Mes offres location ({{(myCars$ | async)!.length}})</h1>
  <div class="buttons-section">
    <button mat-button (click)="openCarEditDialog()" class="cta-button-buy"><mat-icon>add</mat-icon>Ajouter un véhicule</button>
  </div>

  @if (((myCars$ | async) == undefined ) || (myCars$ | async)!.length === 0 ) {
    <h6>
      <br />
      Aucun véhicule dans votre parc
    </h6>
  }

  @if (((myCars$ | async) != undefined )) {
    <div class="cars-section">
      @for (car of (myCars$ | async)!; track car; let i = $index) {
        <div id="{{car.offerId}}" class="car-section">
          <app-provider-offer-card-seller
            [offer]="car"
            [carImagesFolder]="(carImagesFolders$ | async)!.get(car.carId)!"
            [objectSource]="objectSource"
            [currentDealer]="currentSeller" >
          </app-provider-offer-card-seller>
          <br />
        </div>
      }
    </div>
  }
</div>